// extracted by mini-css-extract-plugin
export default {"bounty":"bounty_bounty__QpSSe"};